import { render } from "./GameThreeEntry.vue?vue&type=template&id=99cea1a4"
import script from "./GameThreeEntry.vue?vue&type=script&lang=js"
export * from "./GameThreeEntry.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__